// Correo (SMTP) de Contabilidad. Contabilidad → Configuración.
//
// La configuración existía desde siempre, pero vivía DENTRO de «Envíos
// Programados»: quien buscaba configurar el correo no pensaba en entrar ahí, y
// Control Bancario sí tenía su «Correo (SMTP)» como opción propia. Misma cosa,
// dos tratamientos. Esta pantalla sólo expone el formulario que ya existía.
import { Mail } from 'lucide-react';
import { CardSmtp } from './BIEnvios';

export function CorreoContabilidad() {
  return (
    <div className="p-6 space-y-4 max-w-3xl">
      <div>
        <h1 className="text-xl font-semibold flex items-center gap-2">
          <Mail className="w-5 h-5" /> Correo (SMTP) · Contabilidad
        </h1>
        <p className="text-sm text-muted-foreground">
          Servidor con el que salen los reportes programados de este módulo. Cada módulo usa el suyo:
          configurarlo aquí no afecta al correo de Financiero, Nómina ni Control Bancario.
        </p>
      </div>
      <CardSmtp />
    </div>
  );
}

export default CorreoContabilidad;
